import { useEffect, useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL;

export function useSiteImages() {
  const [images, setImages] = useState({});

  useEffect(() => {
    fetch(`${API}/api/site-images`)
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error("fetch failed"))))
      .then((d) => setImages(d.images || {}))
      .catch(() => {});
  }, []);

  return images;
}
